import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import HomePage from "./pages/Home";
import AboutPage from "./pages/About";
import LeadershipPage from "./pages/Leadership";
import BlogListPage from "./pages/BlogList";
import BlogDetailPage from "./pages/BlogDetail";
import ContactPage from "./pages/Contact";
import SimplePage from "./pages/SimplePage";
import ScrollToTop from "./components/layout/ScrollToTop";

function App() {
  return (
    <>
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/leadership" element={<LeadershipPage />} />
        {/* Projects can later become its own page; for now simple placeholder */}
        <Route path="/projects" element={<SimplePage title="Our Projects" />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/blog" element={<BlogListPage />} />
        <Route path="/blog/insights" element={<BlogDetailPage />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
